'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
interface MarketsHeaderProps {
  category: string | null;
  /** Optional right-aligned actions (e.g. filter, watchlist, search). */
  actions?: React.ReactNode;
}

/**
 * Markets page header: dynamic title based on active category filter,
 * with optional action buttons aligned to the right.
 *
 * "All Markets" when no filter; "<Category> Markets" when filtered.
 */
export function MarketsHeader(t0) {
  const $ = _c(8);
  const {
    category,
    actions
  } = t0;
  const t = useTranslations("markets");
  let t1;
  if ($[0] !== category || $[1] !== t) {
    t1 = category !== null ? t("headingCategory", {
      category
    }) : t("headingAll");
    $[0] = category;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const heading = t1;
  let t2;
  if ($[3] !== heading) {
    t2 = <h1 className="min-w-0 truncate text-heading-md font-semibold">{heading}</h1>;
    $[3] = heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = actions !== undefined && actions;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center justify-between gap-2">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}